import { PDFDownloadLink } from '@react-pdf/renderer';
import Corporate from './Corporate';

const CorporateQuotation = ({ pdfData }) => {
  const fileName = 'CorporateQuotation.pdf';

  return (
    <div className="download-link">
      <center>
        <PDFDownloadLink
          document={<Corporate pdfData={pdfData.quotation_details} mob_no_status={pdfData.mob_no_status}/>}
          fileName={fileName}
          style={{ textDecoration: 'none' }}
        >
          {({ loading }) => (
            <button className="btn btn-success text-white my-3">
              {loading ? 'Preparing document...' : 'Download Corporate Quotation'}
            </button>
          )}
        </PDFDownloadLink>
      </center>
    </div>
  );
};

export default CorporateQuotation;
